import axios from 'axios'
import store from '../store'
import router from '../router'
import { API_BASEURL } from './config'
import * as Cookies from 'tiny-cookie'

axios.defaults.retry = 3
axios.defaults.retryDelay = 1000
axios.defaults.timeout = 10000
axios.defaults.baseURL = API_BASEURL

axios.get = (url, params) => {
  return axios.request({
    url: url,
    method: 'get',
    params: params || {}
  })
}

axios.delete = (url, params) => {
  return axios.request({
    url: url,
    method: 'delete',
    params: params || {}
  })
}

// http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = Cookies.get('access_token')
    if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers['Access-Token'] = `${token}`
    }
    return config
  },
  err => {
    return Promise.reject('network error')
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (!error.response) {
      var config = error.config
      // If config does not exist or the retry option is not set, reject
      if (!config || !config.retry) return Promise.reject('Network Error')

      // Set the variable for keeping track of the retry count
      config.__retryCount = config.__retryCount || 0

      // Check if we've maxed out the total number of retries
      if (config.__retryCount >= config.retry) {
        // Reject with the 'Network Error'
        return Promise.reject('Network Error')
      }

      // Increase the retry count
      config.__retryCount += 1

      // Create new promise to handle exponential backoff
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve()
        }, config.retryDelay * config.__retryCount || 1000)
      })

      // Return the promise in which recalls axios to retry the request
      return backoff.then(function () {
        config.url = config.url.replace(new RegExp(config.baseURL, 'g'), '')
        return axios(config)
      })
    } else if (error.response.status == 401) {
      Cookies.remove('access_token')
      router.replace({
        path: '/',
        query: { redirect: router.currentRoute.fullPath }
      })
      return Promise.reject(error.response.statusText)
    } else if (error.response.status == 422) {
      if (typeof error.response.data === 'string') {
        return Promise.reject('User does not exist or password error')
      } else if (error.response && error.response.data) {
        let arr = []
        Object.keys(error.response.data).forEach(el => {
          arr.push(el + ' ' + error.response.data[el])
        })
        return Promise.reject(arr.join(','))
      } else {
        return Promise.reject(error.response.statusText)
      }
    } else {
      return Promise.reject(error.response.status)
    }
  })

export default axios
